import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import VendorsPageTitle from 'vendors/components/VendorsPageTitle'
import { useTranslation } from 'react-i18next'

type InformationHeaderPropType = {
  companyName: string
  businessId: string
}

const InformationHeader: React.FC<InformationHeaderPropType> = ({ companyName, businessId }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', maxWidth: '650px', pl: 2, pr: 2 }}>
      <VendorsPageTitle>{companyName}</VendorsPageTitle>
      <Typography variant="body2" color="textSecondary">
        {`${t('business-id')}: ${businessId}`}
      </Typography>
    </Box>
  )
}

export default InformationHeader
